export default __webpack_public_path__ + "static/media/nav_arrow.f230f9ff.svg";